import { useContext, useEffect, useState } from 'react';

// Nucleus Components
import { ExperienceContext } from '@thd-nucleus/experience-context';

import { cancelReservation } from '../utils/api';
import {
  CANCEL_CALL_FAILED,
  UNABLE_TO_VALIDATE_CANCEL_CALL,
  NOT_ABLE_TO_CANCEL
} from '../constants/messages';
import { publishToAnalytics } from '../utils/analytics';

const useCancelData = ({ reservationId, uuid, cancelCode }) => {

  const [cancelData, setCancelData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [trigger, setTrigger] = useState(false);

  const ctx = useContext(ExperienceContext);
  const { hosts } = ctx;
  const { apionline } = hosts || {};

  const cancelCall = () => {
    setTrigger(!trigger);
  };

  const fetchData = async () => {
    try {
      setIsLoading(true);
      setIsError(false);
      cancelReservation({ host: apionline, reservationId, uuid, cancelCode })
        .then(() => {
          setCancelData({
            message: `Reservation ID ${reservationId} has been canceled.`,
            type: 'success'
          });
          setIsLoading(false);
        })
        .catch((error) => {
          const errorCode = error?.response?.status;
          const reservationStatus = error?.response?.data?.reservation_status;
          if (errorCode === 406 && reservationStatus) {
            const errorMessage = `Reservation ID ${reservationId} ${NOT_ABLE_TO_CANCEL[reservationStatus]}.`
              + '\nPlease contact your Rental Center for further details.';
            setCancelData({
              message: errorMessage,
              type: 'error'
            });
            setIsLoading(false);
          } else if (errorCode === 400) {
            setCancelData({
              message: UNABLE_TO_VALIDATE_CANCEL_CALL,
              type: 'error'
            });
            setIsLoading(false);
          } else {
            setCancelData({
              message: CANCEL_CALL_FAILED,
              type: 'error'
            });
            setIsLoading(false);
          }
        });
    } catch (error) {
      // eslint-disable-next-line
      console.error(error);
    }
  };

  useEffect(() => {
    if (reservationId && uuid && cancelCode) {
      fetchData();
    } else {
      // eslint-disable-next-line no-lonely-if
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line
        console.log('Missing elements to call availability');
      }
    }
  }, [trigger]);

  return {
    cancelData,
    isLoading,
    isError,
    cancelCall
  };
};

export { useCancelData };
